/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Library_Template_CrumbInputs */

const en_library_template_crumb = /** @type {(inputs: Library_Template_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template`)
};

const pl_library_template_crumb = /** @type {(inputs: Library_Template_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szablon`)
};

/**
* | output |
* | --- |
* | "Template" |
*
* @param {Library_Template_CrumbInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const library_template_crumb = /** @type {((inputs?: Library_Template_CrumbInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Library_Template_CrumbInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_library_template_crumb(inputs)
	return en_library_template_crumb(inputs)
});